import type { FC } from "react";
import { useCallback } from "react";

import classNames from "classnames";

import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

import { LinkCard } from "../../LinkCard/LinkCard";
import type { HeroCardsType } from "../types/HeroV2Types";

import "../HeroV2.global.scss";
import styles from "./HeroCards.module.scss";

export const HeroCards: FC<HeroCardsType> = ({ cards, hasDiscounts = false }) => {
  const handleHeroCardClick = useCallback(
    (label: string) => {
      dispatchTrackingEvent(TrackingEvents.TrackingCtaClick, {
        cta_name: label,
        cta_location: "hero-card",
      });
    },
    [dispatchTrackingEvent]
  );

  return (
    <div
      className={classNames(styles.heroCardsContainer, "grid-container  card-container", {
        [styles.heroCardsContainerWithDiscounts]: hasDiscounts,
      })}
    >
      <div className={styles.heroCards} data-testid="hero-cards-container">
        {cards.map((card, index) => (
          <LinkCard
            key={`${card.label}--${index}`}
            dataTestId={`${card.label}--${index}`}
            onClick={handleHeroCardClick}
            {...card}
          ></LinkCard>
        ))}
      </div>
    </div>
  );
};
